<template>
  <div class="company-info">
    <div class="company-top">
      <div class="bottom-block flex-class-f">
        <div class="bottom-title">
          关于我们
        </div>
        <div class="bottom-cell">
          我们提供全面、准确的行业、公司信息和数据支持；
        </div>
        <div class="bottom-cell">
          无论您是投资人士、企业研究人员或普通用户；
        </div>
        <div class="bottom-cell">
          让您不再需要花费大量时间去寻找有价值的信息。
        </div>
        <div class="bottom-cell m-t-10">
          我们相信科学与技术能够改变专业服务；
        </div>
        <div class="bottom-cell">
          我们希望带给市场多一分理性，少一分似是而非；
        </div>
        <div class="bottom-cell">
          我们认为与众不同的研究和分析，是我们荣誉的唯一来源。
        </div>
      </div>
      <div class="bottom-block ">
        <div class="bottom-block-l">
          <div class="bottom-cell">
            <div class="bottom-cell-l">上海</div>
            <div class="bottom-cell-r">越洋广场47层</div>
          </div>
          <div class="bottom-cell">
            <div class="bottom-cell-l"></div>
            <!-- <div class="bottom-cell-r">港汇广场一座48 + 41 + 33层</div> -->
          </div>
          <div class="bottom-cell">
            <div class="bottom-cell-l">北京</div>
            <div class="bottom-cell-r">国贸三期B座55层</div>
          </div>
          <div class="bottom-cell">
            <div class="bottom-cell-l">成都</div>
            <div class="bottom-cell-r">国金中心一座35层</div>
          </div>
        </div>
      </div>
      <div class="bottom-block ">
        <div class="bottom-block-l">
          <div class="bottom-cell">
            公司名称：久远谦长（北京）管理咨询有限公司
          </div>
          <div class="bottom-cell">
            <a
              href="https://beian.miit.gov.cn/"
              style=" text-decoration: none; "
              target="_blank"
            >
              沪ICP备2024042666号</a
            >
          </div>
          <div class="bottom-cell">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602008355"
              style=""
            ><img src="" style="float:left;" />
              <p style="">
                沪公网安备31010602008355号
              </p></a
            >
          </div>
        </div>
      </div>
      <div class="bottom-block flex-class-t">
        <div class="bottom-title m-b-4">联系方式</div>
        <img
          src="https://meritcomini-bj.oss-accelerate.aliyuncs.com/img/meritco1725279097.png"
          alt="qrcode"
          draggable="false"
          style="width: 120px; height: 120px"
        />
        <div class="bottom-block-r-text">客服企业微信</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    // 关闭浮窗
    handleClose() {
      this.$emit("handleClose")
    }
  }
}
</script>
<style scoped>
.company-info {
  width: 100%;
  font-size: 16px;
  padding: 30px;
}

.company-top {
  /* display: flex; */
  /* justify-content: space-between; */
}

.bottom-block {
  background:#fff;
  padding: 0px 0px 20px 0px;
}

.bottom-block .bottom-block-l {
  width: 375px;
}

.bottom-block .bottom-block-r {
  width: 125px;
}

.bottom-block .bottom-title {
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 20px;
}

.bottom-block .bottom-cell {
  display: flex;
  justify-content: start;
  line-height: 24px;
}

.bottom-block .bottom-cell .bottom-cell-l {
  width: 50px;
}

.bottom-block-r-text {
  margin-top: -4px;
  color: #7C838B;
}

.dis-felx {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.m-b-4 {
  margin-bottom: 4px !important;
}

.bottom-company {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #7C838B;
  text-align: center;
  line-height: 21px;
  margin-bottom: 20px;
}
</style>
